import React from "react";
import { DisabledPrompt, BCMSCurrency } from "bcms-react";
import { TableBody, TableColumnContainer, TableColumnView, TableItemContainer, TableItemTextView, TableItemView, TableView } from "components/shared";

import "./styles.css";
import "./mobile.css";
import { UICheckbox } from "components/ui";
import { SVGAsset } from "res";


/**
 * @function BatchesACHTableView
 * @return {React.Component}
 * @exported true
 * @description This is the main table view used in ActivityACHPage widgets.
 */
export default function BatchesACHTableView(props) {
  const achBatches = props.data.achBatches ?? [];
  const achBatchesItems = achBatches.reduce((acc, item) => {
    if(item.id !== undefined){
      acc.push(
        <ACHBatchesTableRow  key={ item.id } item={ item } />
      );
    }
    return acc;
  }, []);

  const mobileAchBatchesItems = achBatches.reduce((acc, item) => {
    if(item.id !== undefined){
      acc.push(
        <MobileACHBatchesTableRow  key={ item.id } item={ item } />
      );
    }
    return acc;
  }, []);

  return (
    <div className="batches-ach-table-view">
      <div className="show-on-desktop">
        <TableView>
          <TableColumnContainer>
          <TableItemView className="ui-checkbox-column">
          <DisabledPrompt>
            <UICheckbox label="" value="" />
          </DisabledPrompt>
        </TableItemView>
            <TableColumnView className="mini-column text-left" text="Ref #" icon="SortIcon" />
            <TableColumnView className="md-column text-left" text="Batch" icon="SortIcon" />
            <TableColumnView className="mini-column text-left" text="Company" icon="SortIcon" />
            <TableColumnView className="text-right" text="Credit Amount" icon="SortIcon" />
            <TableColumnView className="text-right" text="Debit Amount" icon="SortIcon" />
            <TableColumnView className="text-left" text="Status" icon="SortIcon" />
            <TableColumnView className="text-left" text="Effective Date" icon="SortIcon" />
            <TableColumnView className="text-left" />
          </TableColumnContainer>
          <TableBody>
          { achBatchesItems.length > 0 && achBatchesItems }
          { achBatchesItems.length === 0 && <NoBatchesTableRow colSpan="8" />}
          </TableBody>
        </TableView>
      </div>

      <div className="show-on-mobile">
        <div className="mobile-batches-ach-container">
          { mobileAchBatchesItems.length > 0 && mobileAchBatchesItems }
          { mobileAchBatchesItems.length === 0 &&  <NoBatchesMobileTableRow   />}
        </div>
      </div>
    </div>
  )
}

/**
 * @function NoBatchesTableRow
 * @return {React.Component}
 * @exported true
 * @description This is the main table row used in ACHBatchesTableView.
 */
export function NoBatchesTableRow(props) {
  const colSpan = props.colSpan ?? "6";
  return (
    <TableItemContainer>
      <td colSpan={colSpan} className="text-center table-item-text-view no-batches-table-row-text">There are no batches to display.</td>
    </TableItemContainer>
  )
}

/**
 * @function NoBatchesMobileTableRow
 * @return {React.Component}
 * @exported true
 * @description This is the main table row used in ACHBatchesTableView.
 */
export function NoBatchesMobileTableRow(props) {
  return (
    <div className="no-batches-mobile-table-row">
      <p className="text-center table-item-text-view no-batches-table-row-text">There are no batches to display.</p>
    </div>
  )
}

/**
 * @function ScheduledACHTableView
 * @return {React.Component}
 * @exported true
 * @description This is the main table view used in ActivityACHPage widgets.
 */
export function ScheduledACHTableView(props) {
  const achBatches = props.data.achBatches ?? [];
  const achBatchesItems = achBatches.reduce((acc, item) => {
    if(item.id !== undefined){
      acc.push(
        <ACHBatchesTableRow  key={ item.id } item={ item } />
      );
    }
    return acc;
  }, []);

  const mobileScheduledAchBatchesItems = achBatches.reduce((acc, item) => {
    if(item.id !== undefined){
      acc.push(
        <MobileScheduledACHBatchesTableRow  key={ item.id } item={ item } />
      );
    }
    return acc;
  }, []);
  
  return (
    <div className="scheduled-batches-ach-table-view batches-ach-table-view">
      <div className="show-on-desktop">
        <TableView>
          <TableColumnContainer className="show-on-desktop-table-head">
          <TableItemView className="ui-checkbox-column">
          <DisabledPrompt>
            <UICheckbox label="" value="" />
          </DisabledPrompt>
        </TableItemView>
            <TableColumnView className="mini-column text-left" text="Ref #" icon="SortIcon" />
            <TableColumnView className="md-column text-left" text="Batch" icon="SortIcon" />
            <TableColumnView className="mini-column text-left" text="Company" icon="SortIcon" />
            <TableColumnView className="text-right" text="Credit Amount" icon="SortIcon" />
            <TableColumnView className="text-right" text="Debit Amount" icon="SortIcon" />
            <TableColumnView className="text-left" text="Schedule Status" icon="SortIcon" />
            <TableColumnView className="text-left" text="Effective Date" icon="SortIcon" />
            <TableColumnView className="text-left" />
          </TableColumnContainer>
          <TableBody>
          { achBatchesItems.length > 0 && achBatchesItems }
          { achBatchesItems.length === 0 && <NoBatchesTableRow colSpan="8" />}

          </TableBody>
        </TableView>
      </div>


      <div className="show-on-mobile">
        <div className="mobile-batches-ach-container">
          { mobileScheduledAchBatchesItems.length > 0 && mobileScheduledAchBatchesItems }
          { mobileScheduledAchBatchesItems.length === 0 &&  <NoBatchesMobileTableRow   />}
        </div>
      </div>
    </div>
  )
}

/**
 * @function ACHBatchesTableRow
 * @return {React.Component}
 * @exported true
 * @description This is the main table row used in ACHBatchesTableView.
 */
export function ACHBatchesTableRow(props) {
  const achBatch = props.item ?? {};

  return (
    <TableItemContainer>
      <TableItemView className="ui-checkbox-column">
        <DisabledPrompt>
          <UICheckbox label="" value=""/>
        </DisabledPrompt>
      </TableItemView>
      <TableItemTextView className="ref-number-text" text={achBatch.referenceNumber} />
      <TableItemView className="batch-text">
        <div className="text-container">
          <p className="batch-detail detail">
            <span className="detail-label">Name: </span> <span className="detail-text">{ achBatch.name }</span>
          </p>
          <p className="sec-code-detail detail">
            <span className="detail-label">Sec Code: </span> <span className="detail-text">{ achBatch.secCode }</span>
          </p>
          <p className="transaction-type-detail detail">
            <span className="detail-label">Transaction Type: </span> <span className="detail-text">{ achBatch.transactionType }</span>
          </p>
        </div>
      </TableItemView>
      <TableItemTextView className="company-text" text={<>
        <span>{achBatch.company.name}</span> - <span>{achBatch.company.number}</span>
        </>} />
      <TableItemTextView className="credit-amount-text text-right" text={BCMSCurrency.init(achBatch.creditAmount).format()} />
      <TableItemTextView className="debit-amount-text text-right" text={BCMSCurrency.init(achBatch.debitAmount).format()} />
      <TableItemView className="status-text">
        <div className="text-container">
          <p className="status-detail detail">
            {achBatch.status !==  "canceled" ? 
            <><span className="detail-label">Pending Approval(s):{achBatch.pendingApprovals} </span></> 
            : <span className="detail-text">{achBatch.status}</span>}
          </p>
        </div>
      </TableItemView>
      <TableItemView className="effective-date comment-text">
        <p>{achBatch.effectiveDate.format("m/d/Y")}</p>
        {achBatch.status !== "canceled" && <textarea className="comment-text-area" />}
      </TableItemView>
      <TableItemView className="actions-column">
        <DisabledPrompt>
          <SVGAsset id="MagnifyingGlassIcon" className="magnifying-glass-icon clickable" />
        </DisabledPrompt>
        <DisabledPrompt>
          <SVGAsset id="TrashcanXIcon" className="trash-can-x-icon clickable" />
        </DisabledPrompt>

      </TableItemView>
    </TableItemContainer>
  )
}



/**
 * @function MobileACHBatchesTableRow
 * @return {React.Component}
 * @exported true
 * @description This is the main mobile table row used in ACHBatchesTableView.
 */
function MobileACHBatchesTableRow(props) {
  const achBatch = props.item ?? {};

  return(
    <div className="mobile-ach-batches-row flex-container flex-horizontal align-center space-between">
     {achBatch.status !==  "canceled" &&
      <div className="ach-batch-checkbox set-width">
        <DisabledPrompt>
          <UICheckbox label="" value=""/>
        </DisabledPrompt>
      </div>
}
      <div className="ach-batch-column flex-width">
        <div className="flex-container flex-horizontal space-between ach-batch-item name-reference-number-item">
          <b className="flex-item set-width">{ `${achBatch.name} #${achBatch.referenceNumber} `}</b>
          {/* <p className="set-item flex-width text-right">{ achBatch.amount.format({ style:"decimal" }) }</p> */}
        </div>
        <div className="flex-container flex-horizontal space-between ach-batch-item transaction-type-item">
          <p className="flex-item set-width">{achBatch.transactionType}</p>
          <p className="set-item flex-width text-right"></p>
        </div>
        <div className="flex-container flex-horizontal space-between ach-batch-item credit-amount-item">
          <p className="flex-item set-width">Credit</p>
          <p className="set-item flex-width text-right">{ achBatch.creditAmount.format() }</p>
        </div>
        <div className="flex-container flex-horizontal space-between ach-batch-item debit-amount-item">
          <p className="flex-item set-width">Debit</p>
          <p className="set-item flex-width text-right">{ achBatch.debitAmount.format() }</p>
        </div>
        <div className="flex-container flex-horizontal space-between ach-batch-item effective-date-item">
          <p className="flex-item set-width">Effective Date</p>
          <p className="set-item flex-width text-right">{ achBatch.effectiveDate.format("m/d/Y")}</p>
        </div>

        <div className="flex-container flex-horizontal space-between ach-batch-item status">
          <p className="flex-item set-width">Status:</p>
          <p className="set-item flex-width text-right status-detail detail">
            {achBatch.status !==  "canceled" ? 
            <><span className="detail-label">Pending Approval(s):{achBatch.pendingApprovals} </span></> 
            : <span className="detail-text">{achBatch.status}</span>}
          </p>

        </div>
      </div>
      <div className="ach-batch-actions set-width flex-container flex-vertical align-center">
      <DisabledPrompt><SVGAsset id="MagnifyingGlassIcon" className="inline-text-icon left-icon clickable set-width" /></DisabledPrompt>
      {achBatch.status !==  "canceled" && 
        <>
              {/* <DisabledPrompt><SVGAsset id="EditIcon" className="inline-text-icon left-icon clickable edit-icon set-width" /></DisabledPrompt> */}
              <DisabledPrompt><SVGAsset id="TrashcanXIcon" className="inline-text-icon right-icon clickable set-width" /></DisabledPrompt>
        </>
      }
      </div>
  

    </div>
  );
}



/**
 * @function MobileScheduledACHBatchesTableRow
 * @return {React.Component}
 * @exported true
 * @description This is the main mobile table row used in ScheduledACHTableView.
 */
function MobileScheduledACHBatchesTableRow(props) {
  const achBatch = props.item ?? {};

  return(
    <div className="mobile-ach-batches-row flex-container flex-horizontal align-center space-between">

      <div className="ach-batch-column flex-width">
        <div className="flex-container flex-horizontal space-between ach-batch-item name-reference-number-item">
          <b className="flex-item set-width">{ `${achBatch.name} #${achBatch.referenceNumber} `}</b>
          {/* <p className="set-item flex-width text-right">{ achBatch.amount.format({ style:"decimal" }) }</p> */}
        </div>
        <div className="flex-container flex-horizontal space-between ach-batch-item transaction-type-item">
          <p className="flex-item set-width">{achBatch.transactionType}</p>
          <p className="set-item flex-width text-right"></p>
        </div>
        <div className="flex-container flex-horizontal space-between ach-batch-item credit-amount-item">
          <p className="flex-item set-width">Credit</p>
          <p className="set-item flex-width text-right">{ achBatch.creditAmount.format() }</p>
        </div>
        <div className="flex-container flex-horizontal space-between ach-batch-item debit-amount-item">
          <p className="flex-item set-width">Debit</p>
          <p className="set-item flex-width text-right">{ achBatch.debitAmount.format() }</p>
        </div>
        <div className="flex-container flex-horizontal space-between ach-batch-item effective-date-item">
          <p className="flex-item set-width">Effective Date</p>
          <p className="set-item flex-width text-right">{ achBatch.effectiveDate.format("m/d/Y")}</p>
        </div>

        <div className="flex-container flex-horizontal space-between ach-batch-item status">
          <p className="flex-item set-width">Schedule Status:</p>
          <p className="set-item flex-width text-right status-detail detail">
           <span className="detail-text">{achBatch.status}</span>
          </p>

        </div>
      </div>
      <div className="ach-batch-actions set-width flex-container flex-vertical align-center">
      <DisabledPrompt><SVGAsset id="MagnifyingGlassIcon" className="inline-text-icon left-icon clickable set-width" /></DisabledPrompt>
      {achBatch.status !==  "canceled" && 
        <>
              {/* <DisabledPrompt><SVGAsset id="EditIcon" className="inline-text-icon left-icon clickable edit-icon set-width" /></DisabledPrompt> */}
              <DisabledPrompt><SVGAsset id="TrashcanXIcon" className="inline-text-icon right-icon clickable set-width" /></DisabledPrompt>
        </>
      }
      </div>
  

    </div>
  );
}